/* global keycloak, KC */
jQuery(($) => {
    if ( location.search.indexOf('admin=true') !== -1 ) return;

    var keycloak = new Keycloak(KC.CONFIG);

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Social Links
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    $('.m-social-login-links .a-svg-icon-link').click(function(e) {
        e.preventDefault();

        $('.o-loader').removeClass('a-loader--hidden');

        var idp = $(this).data("platform");
        
        window.location.href = keycloak.createLoginUrl({
            idpHint: idp
        });
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Keycloak Logout
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    $('a[href*="wp-login.php?action=logout"]').click(function(e) {
        keycloak.logout({
            redirectUri: $(this).attr('href')
        });
    });
    
     
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Login Form
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if ( $('.m-login-form')[0] ) {
        $('.m-login-form').each(function(){
            var $login    = $(this),
                $form     = $login.find('form'),
                $user     = $form.find('input[name="log"]'),
                $pass     = $form.find('input[name="pwd"]'),
                $redirect = $form.find('input[name="redirect_to"]');

            $form.submit(function(e) {
                e.preventDefault();

                $('.m-login-form__loader').removeClass('a-loader--hidden');

                $.post(KC.AJAX.URL, $form.serialize(), (res) => {
                    if (res.success) {
                        window.location.href = res.data;
                    } else {
                        $('.m-login-form__loader').addClass('a-loader--hidden');
                        $('.m-login-form__error').remove();
                        $('.m-login-form__fields').append(`<div class="m-login-form__error">${res.data}</div>`);
                    }
                });
            });
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Register Form
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if ( $('.m-register-form')[0] ) {
        var $register  = $('.m-register-form'),
            $form      = $register.find('form');

        $.validator.addMethod("above13", function(value, element, param) {
            var day   = $(`[name="${param[0]}"]`).val(),
                month = $(`[name="${param[1]}"]`).val(),
                year  = $(`[name="${param[2]}"]`).val();

            if ( !day || !month || !year ) return false;

            var limit    = new Date(),
                birthday = new Date(year, (month - 1), day);

            limit.setFullYear(limit.getFullYear() - 13);

            return birthday.getTime() <= limit.getTime();
        }, "Must be at least 13 years old.");
        
        var validator = $form.validate({
            rules: {
                log: {
                    pattern: "^([a-zA-Z0-9_+\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$"
                },
                pwd: {
                    pattern: "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\\d)(?=.*[^\\da-zA-Z]).{8,}$"
                },
                cpwd: {
                    equalTo: "#pwd"
                },
                birthday: {
                    above13: ['birthday', 'birthmonth', 'birthyear']
                }
            },
            messages: {
                log: 'Please enter a valid email address'
            },
            ignore: function (index, el) {
                if ($(el).hasClass('a-select__native') && !$(el).closest('.m-field--hidden')[0]) {
                    return false;
                }

                return $(el).is(':hidden');
            },
            errorPlacement: function(error, element) {
                error.appendTo( $(element).closest(".m-field") );
            },
            highlight: function(element, errorClass, validClass) {
                $(element).closest(".m-field").addClass('m-field--error').removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).closest(".m-field").removeClass('m-field--error').addClass(validClass);
            },
            submitHandler: function(form) {
                $('.m-register-form__loader').removeClass('a-loader--hidden');
        
                $.post(KC.AJAX.URL, $form.serialize(), (res) => {
                    if (res.success) {
                        window.location.href = res.data;
                    } else {
                        $('.m-register-form__loader').addClass('a-loader--hidden');
                        $('.m-register-form__error').remove();
                        $('.m-register-form__fields').append(`<div class="m-register-form__error">${res.data}</div>`);
                    }
                });
            }
        });

        $('.m-field__select').on('chooseSelectOption', function() {
            var $select = $(this).find('select'),
                name    = $select.attr('name');

            validator.element($select);

            if ( name == 'birthmonth' || name == 'birthyear' ) {
                validator.element($('[name="birthday"]'));
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Register Form
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if ( $('.m-update-account-form')[0] ) {
        var $update  = $('.m-update-account-form'),
            $form    = $update.find('form');

        $.validator.addMethod("above13", function(value, element, param) {
            var day   = $(`[name="${param[0]}"]`).val(),
                month = $(`[name="${param[1]}"]`).val(),
                year  = $(`[name="${param[2]}"]`).val();

            if ( !day || !month || !year ) return false;

            var limit    = new Date(),
                birthday = new Date(year, (month - 1), day);

            limit.setFullYear(limit.getFullYear() - 13);

            return birthday.getTime() <= limit.getTime();
        }, "Must be at least 13 years old.");
        
        var validator = $form.validate({
            rules: {
                log: {
                    pattern: "^([a-zA-Z0-9_+\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$"
                },
                birthday: {
                    above13: ['birthday', 'birthmonth', 'birthyear']
                }
            },
            messages: {
                log: 'Please enter a valid email address'
            },
            ignore: function (index, el) {
                if ($(el).hasClass('a-select__native') && !$(el).closest('.m-field--hidden')[0]) {
                    return false;
                }

                return $(el).is(':hidden');
            },
            errorPlacement: function(error, element) {
                error.appendTo( $(element).closest(".m-field") );
            },
            highlight: function(element, errorClass, validClass) {
                $(element).closest(".m-field").addClass('m-field--error').removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).closest(".m-field").removeClass('m-field--error').addClass(validClass);
            },
            submitHandler: function(form) {
                $('.m-update-account-form__loader').removeClass('a-loader--hidden');
        
                $.post(KC.AJAX.URL, $form.serialize(), (res) => {
                    if (res.success) {
                        window.location.href = res.data;
                    } else {
                        $('.m-update-account-form__loader').addClass('a-loader--hidden');
                        $('.m-update-account-form__error').remove();
                        $('.m-update-account-form__fields').append(`<div class="m-update-account-form__error">${res.data}</div>`);
                    }
                });
            }
        });

        $('.m-field__select').on('chooseSelectOption', function() {
            var $select = $(this).find('select'),
                name    = $select.attr('name');

            validator.element($select);

            if ( name == 'birthmonth' || name == 'birthyear' ) {
                validator.element($('[name="birthday"]'));
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Reset Password Form
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if ( $('.m-forgot-password-form')[0] ) {
        var $forgotpassword = $('.m-forgot-password-form'),
            $form           = $forgotpassword.find('form');
        
        $form.submit(function(e) {
            e.preventDefault();

            $('.m-forgot-password-form__loader').removeClass('a-loader--hidden');
    
            $.post(KC.AJAX.URL, $form.serialize(), (res) => {
                if (res.success) {
                    window.location.href = res.data;
                } else {
                    $('.m-forgot-password-form__loader').addClass('a-loader--hidden');
                    $('.m-forgot-password-form__error').remove();
                    $('.m-forgot-password-form__fields').append(`<div class="m-forgot-password-form__error">${res.data}</div>`);
                }
            });
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Login Page
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    if ( $('#loginform')[0] ) {
        var $form    = $('#loginform'),
            $user     = $form.find('input[name="log"]'),
            $pass     = $form.find('input[name="pwd"]'),
            $redirect = $form.find('input[name="redirect_to"]');
    
        $form.submit((e) => {
            e.preventDefault();

            $('.a-loader').removeClass('a-loader--hidden');
    
            $.post(KC.AJAX.URL, {
                action: KC.AJAX.ACTIONS.LOGIN,
                username: $user.val(),
                password: $pass.val(),
                redirect: $redirect.val(),
            }, (res) => {
                if (res.success) {
                    window.location.href = res.data;
                } else {
                    $('.a-loader').addClass('a-loader--hidden');
                    $('#login_error').remove();
                    $('#login_notice').remove();
                    $('#login > h1').after(`<div id="login_error">${res.data}</div>`);
                }
            });
        });
    }
});